import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab53c956"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "application-item-box" }
const _hoisted_2 = { class: "application-title" }
const _hoisted_3 = {
  key: 0,
  class: "application-reason"
}
const _hoisted_4 = {
  key: 1,
  class: "application-operat"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_button = _resolveComponent("ui-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.typeText) + " ￥" + _toDisplayString(_ctx.modelValue.amount || 0), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["application-status", _ctx.statusClass])
    }, _toDisplayString(_ctx.statusText), 3),
    (_ctx.modelValue.reason)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "原因：" + _toDisplayString(_ctx.modelValue.reason), 1))
      : _createCommentVNode("", true),
    (_ctx.canAudit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_ui_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.audit(1)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("同意")
            ]),
            _: 1
          }),
          _createVNode(_component_ui_button, {
            type: "danger",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.audit(2)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("拒绝")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}